// extracted by mini-css-extract-plugin
module.exports = {"Form":"SignInForm_Form__Mgnia","FormElements":"SignInForm_FormElements__2iILV"};